import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalStateService {

  constructor() { }

  public csvDownloadInProgress = new Subject<boolean>();

  public rowsPerPage = new BehaviorSubject<number>(15);

  public setCsvDownloading(downloading: boolean) {
    this.csvDownloadInProgress.next(downloading);
  }

  public setRowsPerPage(numberOfRows: number) {
    this.rowsPerPage.next(numberOfRows);
  }
}
